import { PAGE_PUBLISH_ERROR_MESSAGES } from '@builder4/shared/utils/constants';
import { domainValidation, pathValidation } from '@builder4/shared/utils/regex';

export const domainAndPathValidation = (domain: string | null, path: string | null): void => {
  if (!path) throw new Error(PAGE_PUBLISH_ERROR_MESSAGES.MISSING_PATH);
  if (!domain) throw new Error(PAGE_PUBLISH_ERROR_MESSAGES.MISSING_DOMAIN);
  if (!domainValidation.test(domain.trim().toLowerCase()))
    throw new Error(PAGE_PUBLISH_ERROR_MESSAGES.INVALID_DOMAIN(domain));
  if (!pathValidation.test(path.trim().toLowerCase()))
    throw new Error(PAGE_PUBLISH_ERROR_MESSAGES.INVALID_PATH(path));
};

export const pageNameValidation = (pageName: string | null) => {
  if (!pageName) throw new Error(PAGE_PUBLISH_ERROR_MESSAGES.MISSING_NAME);
};
